/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';

import './CarbonTitleField.scss';

function CarbonTitleField(props) {
    const { id, title, required, formContext } = props;

    let legend = title;

    if (id !== 'root__title') {
        // Only add optionalLabel when it's not the root title
        legend += (!required && formContext && formContext.optionalLabel ? ` (${formContext.optionalLabel})` : '');
    }

    return <div id={id} className="baiw--form-title-field">{legend}</div>;
}

export { CarbonTitleField };